import React, { useState, useEffect, useContext } from 'react';
import {
  Form,
  Radio,
  InputNumber,
  Checkbox,
  Modal,
  Button,
  Icon,
  Row,
  Col,
  Spin,
  Input,
} from 'antd';
import QuotationTemplate from '../QuotationTemplate';
import './index.less';
import { network, generators } from '../../../utils';
import api from '../../../config/api';
import Context from '../../layout/Container/Context';
import moment from 'moment';

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

const { generatorArray } = generators;

export default Form.create()(
  ({
    form,
    visible,
    onConfirm,
    onCancel,
    dataSourceLength = 0,
    loading = false,
    showAddProcess = true,
  }) => {
    const { getFieldDecorator, validateFields } = form;
    const [adjustType, setAdjustType] = useState('NONE');
    const [addProcessOptions, setAddProcessOptions] = useState([]);
    const [mutexArr, setMutexArr] = useState([]);
    const [exploreMaxLines, setExploreMaxLines] = useState(0);
    const { history } = React.useContext(Context);
    const initDocName = `报价单_${moment().format('YYYYMMDDHHmmss')}`;

    useEffect(() => {
      async function fetchData() {
        const response = await network.get(api.quotation.addProcess);
        if (response.success) {
          setAddProcessOptions(generatorArray(response.data.data));
        }
      }
      if (showAddProcess) fetchData();
    }, []);

    useEffect(() => {
      const fetchExploreMaxLines = async () => {
        const configCode = 'exploreMaxLines';
        const res = await network.get(api.finance.introduction, {
          params: { confCode: configCode },
        });
        if (res.success) {
          const { rows = [] } = generators.generatorObject(res.data);
          const Obj = generators.generatorObject(
            rows.filter(({ confCode }) => confCode === configCode)[0],
          );
          const exploreMaxLines = +Obj['confValue'];
          setExploreMaxLines(exploreMaxLines);
        } else {
          setExploreMaxLines(0);
        }
      };
      fetchExploreMaxLines();
    }, []);

    // 关闭当前弹窗
    const handleCancel = () => {
      onCancel && onCancel();
    };

    const handleConfirm = () => {
      const params = form.getFieldsValue();
      if (params.addProcess) params.addProcess = params.addProcess.join(',');
      if (params.adjustRate) {
        params.adjustRate = params.adjustRate / 100;
      }
      onConfirm && onConfirm(params);
    };

    const gotoQuotationHistory = () => {
      history.push('/profile/historical');
    };

    const renderQuotation = () => {
      return (
        <>
          <Form {...formItemLayout}>
            <Form.Item label="获取报价" className="quotationItem">
              {getFieldDecorator('priceType', { initialValue: '1' })(
                <Radio.Group>
                  <Radio value="1">活动价格</Radio>
                  <Radio value="2">非活动价格</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
            <Form.Item label="报价调整" className="quotationItem">
              {getFieldDecorator('adjustType', {
                initialValue: 'NONE',
              })(
                <Radio.Group
                  onChange={(e) => {
                    const { value } = e.target;
                    setAdjustType(value);
                    if (value === 'NONE')
                      form.setFieldsValue({
                        adjustRate: 0,
                      });
                  }}
                >
                  <Radio value="NONE">不调整</Radio>
                  <Radio value="UP">价格上调</Radio>
                  <Radio value="DOWN">价格下调</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
            {adjustType != 'NONE' ? (
              <Form.Item label="调整比例" className="quotationItem">
                {getFieldDecorator('adjustRate', {
                  initialValue: 0,
                })(
                  <InputNumber
                    min={0}
                    max={100}
                    formatter={(value) => `${value}%`}
                    parser={(value) => value.replace('%', '')}
                  />,
                )}
                <span style={{ marginLeft: '10px' }}>
                  {`最终价为: 获取报价${adjustType === 'UP' ? '*' : '/'}(1+${form.getFieldValue(
                    'adjustRate',
                  )}%)`}
                </span>
              </Form.Item>
            ) : null}
            <Form.Item label="报价单名称" className="quotationItem">
              {getFieldDecorator('docName', {
                initialValue: initDocName,
              })(<Input style={{ width: '50%', fontFamily: 'Microsoft Yahei' }} />)}
            </Form.Item>
            {showAddProcess ? (
              <Form.Item label="增值服务" className="quotationItem">
                {getFieldDecorator('addProcess')(
                  <Checkbox.Group
                    onChange={(selectVals) => {
                      const proMutexStrArr = addProcessOptions
                        .filter((item) => selectVals.includes(item.proCode))
                        .map((item) => item.proMutex);
                      const mutexArrTemp = [...new Set(proMutexStrArr.join(',').split(','))];
                      setMutexArr(mutexArrTemp);
                    }}
                  >
                    {addProcessOptions.map((v, i) => (
                      <Checkbox
                        value={v.proCode}
                        key={v.proCode}
                        disabled={mutexArr.includes(v.proCode)}
                        className="blockInlineStyle"
                        style={{ margin: 0 }}
                      >
                        {v.proDesc}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>,
                )}
              </Form.Item>
            ) : null}

            <div
              style={{
                marginLeft: '30px',
                backgroundColor: '#EDF4FF',
                padding: '0 10px',
                marginRight: '20px',
              }}
            >
              {
                // 这个页面不需要提示了
                // dataSourceLength > exploreMaxLines ?
                //   <Row >
                //     <Col span={1}><Icon type="exclamation-circle" theme="filled" style={{ color: '#5297F8' }} /></Col>
                //     <Col span={23}><div>批次操作最多为{exploreMaxLines}条,建议做精准筛选报价</div></Col>
                //   </Row>
                //   : null
              }
              {showAddProcess ? (
                <>
                  <Row>
                    <Col span={1}>
                      <Icon type="exclamation-circle" theme="filled" style={{ color: '#5297F8' }} />
                    </Col>
                    <Col span={23}>
                      <div>增值服务，默认按最小起订量计算。</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={1}>
                      <Icon type="exclamation-circle" theme="filled" style={{ color: '#5297F8' }} />
                    </Col>
                    <Col span={23}>
                      <div>
                        此处增值服务仅供参考，具体收费及是否可做，下单时详见增值服务说明或咨询专属客服。
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={1}>
                      <Icon type="exclamation-circle" theme="filled" style={{ color: '#5297F8' }} />
                    </Col>
                    <Col span={23}>
                      <div>
                        选增值服务导出时间较长，如需详细的增值服务报价配置，建议您添加商品到购物车同时添加增值服务来生成报价单。
                      </div>
                    </Col>
                  </Row>
                </>
              ) : null}
            </div>
          </Form>
        </>
      );
    };

    return (
      <>
        <Modal
          title={
            <span>
              <Icon type="money-collect" /> 报价选项
            </span>
          }
          width="500px"
          visible={visible}
          className="quotationModal"
          onCancel={handleCancel}
          bodyStyle={{ padding: '20px 0' }}
          maskClosable={false}
          footer={
            <>
              <Button onClick={handleCancel}>取消</Button>
              <Button type="btn-info" onClick={handleConfirm}>
                生成报价单
              </Button>
              <span
                className="gotoHistory"
                onClick={() => {
                  handleCancel();
                  gotoQuotationHistory();
                }}
              >
                <Icon type="info-circle" /> 查看历史报价单
              </span>
            </>
          }
        >
          <Spin spinning={loading}>{renderQuotation()}</Spin>
        </Modal>
      </>
    );
  },
);
